import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-address",
  "use": "foquz-icon-question-address-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol viewBox=\"0 0 18 24\" fill=\"none\" id=\"foquz-icon-question-address\"><path d=\"M17 9c0 5.5-8 13-8 13S1 14.5 1 9s3.582-8 8-8 8 2.5 8 8z\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M13 9a4 4 0 11-8 0 4 4 0 018 0z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol